exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#medical-record-viewer #medical-record-viewer__textarea{background:#fff;cursor:default}", ""]);

// exports
